export default __webpack_public_path__ + "c4df8b383225e414b7451c8f3ad0507c.png";